module.exports = __webpack_public_path__ + "img/submit.39190c96.gif";